
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']
import GlobalConfig from '../../../../globals/globalConfig.json'
export default function routes($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true);
  $stateProvider
    .state('generalSettings.notificationsManagement', {
      abstract: false,
      url: '/notificationsManagement',
      template: require('./list/notificationsList.html'),
      controller: 'NotificationsListCtrl',
      controllerAs:'notificationListVM',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2,
          },
          {
            name: 'generalSettings.users',
            order: 3,
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4,
          }
        ]
      },
    })
    .state('generalSettings.customNotification', {
      abstract: false,
      url: '/customNotification',
      template: require('./custom/customNotification.html'),
      controller: 'CustomNotificationCtrl',
      controllerAs:'customNotificationVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2,
          },
          {
            name: 'generalSettings.users',
            order: 3,
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4,
          }
        ]
      },
    })
    .state('generalSettings.customNotificationDetail', {
      abstract: false,
      url: '/customNotification/:notificationId/view',
      template: require('./custom/customNotificationDetail.html'),
      controller: 'CustomNotificationDetailCtrl',
      controllerAs:'customNotificationVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2,
          },
          {
            name: 'generalSettings.users',
            order: 3,
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4,
          }
        ]
      },
    })
    .state('generalSettings.notificationRule', {
      abstract: false,
      url: '/notificationRule',
      template: require('./rules/notificationRule.html'),
      controller: 'NotificationRuleCtrl',
      controllerAs:'notificationRuleVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      },
    })
    .state('generalSettings.editNotificationRule', {
      abstract: false,
      url: '/notificationRule/:notificationId/edit',
      template: require('./rules/notificationRule.html'),
      controller: 'NotificationRuleCtrl',
      controllerAs:'notificationRuleVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      },
    })
    .state('generalSettings.notificationRuleDetail', {
      abstract: false,
      url: '/notificationRule/:notificationId/view',
      template: require('./rules/notificationRuleDetail.html'),
      controller: 'NotificationRuleDetailCtrl',
      controllerAs:'notificationRuleVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      },
    })
    .state('generalSettings.initialMessageNotification', {
      abstract: false,
      url: '/initialMessageNotification',
      template: require('./startMessage/startMessageNotification.html'),
      controller: 'StartMessageNotificationCtrl',
      controllerAs:'startMessageVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      },
    })
    .state('generalSettings.startMessageNotificationDetail', {
      abstract: false,
      url: '/startMessageNotification/:notificationId/view',
      template: require('./startMessage/startMessageNotificationDetail.html'),
      controller: 'StartMessageNotificationDetailCtrl',
      controllerAs:'startMessageNotificationVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      },
    })
    .state('generalSettings.editStartMessageNotification', {
      abstract: false,
      url: '/startMessageNotification/:notificationId/edit',
      template: require('./startMessage/startMessageNotification.html'),
      controller: 'StartMessageNotificationCtrl',
      controllerAs:'startMessageVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      },
    })
    .state('generalSettings.editCustomNotification', {
      abstract: false,
      url: '/customNotification/:notificationId/edit',
      template: require('./custom/customNotification.html'),
      controller: 'CustomNotificationCtrl',
      controllerAs:'customNotificationVm',
      data: {
        displayName: 'Gestión de notificaciones',
        order: 1,
        siblings:[
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2,
          },
          {
            name: 'generalSettings.users',
            order: 3,
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4,
          }
        ]
      },
    })

}



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/notifications.route.js